import request from '@/api/axios' // 引入axios文件
// 查询部门树
export const getDepartTree = (params) =>
	request({
		url: '/api/dept/tree',
		method: 'get',
		params: params
	})
// 上移下移
export const upDownDept1 = (data) =>
	request({
		url: '/api/dept/upDownDept/1',
		method: 'put',
		data
	})
// 下移
export const upDownDept2 = (data) =>
	request({
		url: '/api/dept/upDownDept/2',
		method: 'put',
		data
	})
// 添加部门
export const addDepart = (data) =>
	request({
		url: '/api/dept',
		method: 'post',
		data
	})
// 删除部门
export const delDepart = (data) =>
	request({
		url: '/api/dept',
		method: 'delete',
		data
	})

// // 上传文件接口
// export const uploadData = (data) => {
// 	request({
// 		url: '/api/localStorage/pictures',
// 		method: 'post',
// 		data
// 	})
// }

// 获取团队比赛信息列表
export const queryMsgTrem = (params) =>
	request({
		url: '/api/userMessage/queryMsgTrem',
		method: 'get',
		params: params
	})
// 消息管理添加消息通知
export const saveMsgTrem = (data) =>
	request({
		url: '/api/userMessage/saveMsgTrem',
		method: 'post',
		data
	})

// 查询部门树
export const getMatchList = (params) =>
	request({
		url: '/api/match',
		method: 'get',
		params: params
	})
// 查询部门树
export const getMatchById = (params) =>
	request({
		url: '/api/match/getMatchById',
		method: 'get',
		params: params
	})
// 下移
export const updateMatchStatus = (data) =>
	request({
		url: '/api/match/updateMatchStatus',
		method: 'put',
		data
	})

// 创建赛事
export const createMatch = (data) =>
	request({
		url: '/api/match/create',
		method: 'post',
		data
	})
// 赛事修改
export const updateMatch = (data) =>
	request({
		url: '/api/match/update',
		method: 'put',
		data
	})
// 赛事置顶状态修改
export const updateMatchTopStatus = (data) =>
	request({
		url: '/api/match/updateMatchTopStatus',
		method: 'put',
		data
	})

// 文件上传
export function uploadFile(obj) {
	return request({
		url: '/api/localStorage/pictures',
		method: 'POST',
		data: obj,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}
// 数据上传
export function uploadlocalStorage(obj) {
	return request({
		url: '/api/localStorage',
		method: 'POST',
		data: obj,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}
// 查询全量比赛及赛程列表
export const searchMatchAndSchedule = (params) =>
	request({
		url: '/api/match/searchMatchAndSchedule',
		method: 'get',
		params: params
	})
// 查询全量比赛及赛程列表
export const queryScheduleAndTeamByParam = (params) =>
	request({
		url: '/api/match/queryScheduleAndTeamByParam',
		method: 'get',
		params: params
	})
// 下载全部
export const downloadAll = (params) =>
	request({
		// url: '/api/match/download',
		url: '/api/match/downloadResult',
		method: 'get',
		params: params
		// responseType: 'arraybuffer'
	})
// 下载选中
export const downloadByRelationIds = (params) =>
	request({
		// url: '/api/match/downloadByRelationIds',
		url: '/api/match/downloadResultByRelationIds',
		method: 'get',
		params: params
		// responseType: 'arraybuffer'
	})
// 赛事状态修改
export const examineScheduleAndTeam = (data) =>
	request({
		url: '/api/match/examineScheduleAndTeam',
		method: 'put',
		data
	})
// 查询帖子列表
export const postForum = (params) =>
	request({
		url: '/api/postForum',
		method: 'get',
		params: params
	})
// 帖子审核
export const examinePostForum = (data) =>
	request({
		url: '/api/postForum/examinePostForum',
		method: 'put',
		data
	})
// 帖子批量操作
export const operatorPostForum = (data) =>
	request({
		url: '/api/postForum/operatorPostForum',
		method: 'put',
		data
	})
// 服务管理模块查询所有比赛
export const queryMatchName = (params) =>
	request({
		url: '/api/modelInfo/queryMatchName',
		method: 'get',
		params: params
	})
// 服务管理模块查询当前比赛下的模型
export const queryAllModel = (params) =>
	request({
		url: '/api/modelInfo/queryAllModel',
		method: 'get',
		params: params
	})
// 服务管理列表
export const getAllServiceInfo = (params) =>
	request({
		url: '/api/serviceManage/getAllServiceInfo',
		method: 'get',
		params: params
	})
// 服务信息创建
export const createServiceManage = (data) =>
	request({
		url: '/api/serviceManage/create',
		method: 'post',
		data
	})
// 服务信息编辑
export const updateServiceManage = (data) =>
	request({
		url: '/api/serviceManage/update',
		method: 'put',
		data
	})
// 服务详情
export const getServiceInfoById = (params) =>
	request({
		url: '/api/serviceManage/getServiceInfoById',
		method: 'get',
		params: params
	})
// 修改服务状态（上下线，删除）
export const updateServiceInfoStatus = (data) =>
	request({
		url: '/api/serviceManage/updateServiceInfoStatus',
		method: 'put',
		data
	})
// 查找所有的模型类型
export const queryModelType = (params) =>
	request({
		url: '/api/modelInfo/queryModelType',
		method: 'get',
		params: params
	})
// 查找所有的运行状态
export const queryFunctionStatus = (params) =>
	request({
		url: '/api/modelInfo/queryFunctionStatus',
		method: 'get',
		params: params
	})
// 分页条件查询模型列表
export const getModelInfo = (params) =>
	request({
		url: '/api/modelInfo',
		method: 'get',
		params: params
	})

// 修改上线状态
export const updateModelOnlineStatus = (data) =>
	request({
		url: '/api/modelInfo/updateModelOnlineStatus',
		method: 'put',
		data
	})
// 权限
export const treeRoleALLByuserId = (params) =>
	request({
		url: '/api/roleAuthority/treeRoleALLByuserId',
		method: 'get',
		params: params
	})

// b端首页数据统计
// 统计今日比赛数
export const todayMatchCount = (params) =>
	request({
		url: '/api/statistics/todayMatchCount',
		method: 'get',
		params: params
	})
// B端今日新增报名用户和团队
export const todaySignTeamAndMember = (params) =>
	request({
		url: '/api/statistics/todaySignTeamAndMember',
		method: 'get',
		params: params
	})
// B端新增报名用户和团队趋势
export const signTeamAndMemberTrend = (params) =>
	request({
		url: '/api/statistics/signTeamAndMemberTrend',
		method: 'get',
		params: params
	})
// B端各项比赛数据集下载排名
export const matchDownloadCount = (params) =>
	request({
		url: '/api/statistics/matchDownloadCount',
		method: 'get',
		params: params
	})
// B端各项比赛任务提交总量排名
export const matchSubmitCount = (params) =>
	request({
		url: '/api/statistics/matchSubmitCount',
		method: 'get',
		params: params
	})
// B端比赛各赛程下载数据情况
export const scheduleDownloadCountByMatchId = (params) =>
	request({
		url: '/api/statistics/scheduleDownloadCountByMatchId',
		method: 'get',
		params: params
	})
// B端比赛成果试用次数趋势
export const getResultClick = (params) =>
	request({
		url: '/api/statistics/getResultClick',
		method: 'get',
		params: params
	})
